import { Box, Card, ListSubheader, Stack, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Bound } from "lib/@components/binding/Bound"
import { CompareTitleRight, CompareTitleTop, ScheduleHeaderToolbar } from "slot-definitions"
import { ContextMenuBar } from "lib/@components/context-menu-bar"
import { useState } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { CanSaveApprovedDocument } from "event-definitions"
import { noop } from "lib/noop"

export function CompareTitle({ leftCaption = "Your Version", rightCaption = "Comparison", name, otherVersionName }) {
    const { target, readOnly, leftSx, rightSx, canSave: editable } = useBoundContext()
    const [canSave, setCanSave] = useState()
    const handler = readOnly || !editable ? noop : setCanSave
    CanSaveApprovedDocument.useEvent(handler)
    const hideComparison = !readOnly && !!editable && !!canSave

    return (
        <ListSubheader sx={{ mb: 1, mx: -3, zIndex: 2 }}>
            <Stack spacing={2}>
                <Card sx={{ borderRadius: 1 }}>
                    <Bound editMode={false} timelineOn>
                        <ListItemBox py={1} bgcolor="background.default" spacing={1}>
                            <Box flex={1} />
                            <ScheduleHeaderToolbar.Slot schedule={target}>
                                <ContextMenuBar type="schedule" priority={1000} />
                            </ScheduleHeaderToolbar.Slot>
                        </ListItemBox>
                    </Bound>
                    <CompareTitleTop.Slot />
                </Card>
                <ListItemBox sx={{ borderRadius: 1, overflow: "hidden" }} alignItems="stretch" data-cy="compare-title">
                    <Box
                        flex={1}
                        p={1}
                        sx={{
                            bgcolor: "primary.main",
                            borderRadius: hideComparison ? 1 : 0,
                            borderTopLeftRadius: 1,
                            borderBottomLeftRadius: 1,
                            ...leftSx,
                        }}
                        data-cy="left-compare-title"
                    >
                        <Typography variant="h6" sx={{ color: "primary.contrastText" }}>
                            {leftCaption}
                        </Typography>
                        <TruncatedTypography
                            sx={{ color: "primary.contrastText", opacity: 0.8 }}
                            variant="body2"
                            data-cy="new-version-name"
                        >
                            {name}
                        </TruncatedTypography>
                    </Box>
                    <Box
                        flex={1}
                        p={1}
                        sx={{
                            minWidth: 0,
                            opacity: hideComparison ? 0 : 1,
                            textAlign: "right",
                            bgcolor: "primary.darker",
                            borderTopRightRadius: 1,
                            borderBottomRightRadius: 1,
                            ...rightSx,
                        }}
                        data-cy="right-compare-title"
                    >
                        <Typography variant="h6" sx={{ color: "primary.contrastText" }}>
                            {rightCaption}
                        </Typography>
                        <Stack direction={"row"}>
                            <TruncatedTypography
                                sx={{
                                    color: "primary.contrastText",
                                    opacity: 0.8,
                                }}
                                variant="body2"
                                data-cy="other-version-name"
                            >
                                {otherVersionName}
                            </TruncatedTypography>
                            <CompareTitleRight.Slot />
                        </Stack>
                    </Box>
                </ListItemBox>
            </Stack>
        </ListSubheader>
    )
}
